// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModelVersionRequestStatusModal-module__dsAccented--lGt3E,.ModelVersionRequestStatusModal-module__dsAccented--lGt3E *{font-weight:500}.ModelVersionRequestStatusModal-module__dsDefaultWeight--Z2GpU,.ModelVersionRequestStatusModal-module__dsDefaultWeight--Z2GpU *{font-weight:400}h5.ModelVersionRequestStatusModal-module__dsAccented--lGt3E,h5.ModelVersionRequestStatusModal-module__dsAccented--lGt3E *{font-weight:700}.ModelVersionRequestStatusModal-module__dsUnderline--NFsql,.ModelVersionRequestStatusModal-module__dsUnderline--NFsql *{text-decoration:underline}.ModelVersionRequestStatusModal-module__dsAccented2--DdP_v,.ModelVersionRequestStatusModal-module__dsAccented2--DdP_v *{font-weight:700}.ModelVersionRequestStatusModal-module__dsBodyXL--KMKOQ,.ModelVersionRequestStatusModal-module__dsBodyXL--KMKOQ *{font-size:18px;line-height:27px}.ModelVersionRequestStatusModal-module__dsBodyLarge--qIeQx,.ModelVersionRequestStatusModal-module__dsBodyLarge--qIeQx *{font-size:16px;line-height:24px}.ModelVersionRequestStatusModal-module__dsBody--AlUL_,.ModelVersionRequestStatusModal-module__dsBody--AlUL_ *{font-size:14px;line-height:20px}.ModelVersionRequestStatusModal-module__dsBodySmall--XTiaP,.ModelVersionRequestStatusModal-module__dsBodySmall--XTiaP *{font-size:12px;line-height:18px}.ModelVersionRequestStatusModal-module__dsBodyXS--uOgCm,.ModelVersionRequestStatusModal-module__dsBodyXS--uOgCm *{font-size:10px;line-height:15px}.ModelVersionRequestStatusModal-module__dsActionLarge--HKdcp,.ModelVersionRequestStatusModal-module__dsActionLarge--HKdcp *{font-size:16px;line-height:18px}.ModelVersionRequestStatusModal-module__dsAction--ba3vI,.ModelVersionRequestStatusModal-module__dsAction--ba3vI *{font-size:14px;line-height:16px}.ModelVersionRequestStatusModal-module__dsActionSmall--iOaPi,.ModelVersionRequestStatusModal-module__dsActionSmall--iOaPi *{font-size:12px;line-height:14px}.ModelVersionRequestStatusModal-module__dsColumnHeadLine--Hqu3n,.ModelVersionRequestStatusModal-module__dsColumnHeadLine--Hqu3n *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.ModelVersionRequestStatusModal-module__dsLightXL--XhecA,.ModelVersionRequestStatusModal-module__dsLightXL--XhecA *{font-size:120px;line-height:160px;font-weight:300}.ModelVersionRequestStatusModal-module__dsLightLarge--TRIGq,.ModelVersionRequestStatusModal-module__dsLightLarge--TRIGq *{font-size:48px;line-height:64px;font-weight:300}.ModelVersionRequestStatusModal-module__dsLight--SvZ_v,.ModelVersionRequestStatusModal-module__dsLight--SvZ_v *{font-size:32px;line-height:64px;font-weight:300}.ModelVersionRequestStatusModal-module__dsLightSmall--nDxLn,.ModelVersionRequestStatusModal-module__dsLightSmall--nDxLn *{font-size:24px;line-height:36px;font-weight:300}.ModelVersionRequestStatusModal-module__dsLightXS--rH_1Q,.ModelVersionRequestStatusModal-module__dsLightXS--rH_1Q *{font-size:18px;line-height:27px;font-weight:300}.ModelVersionRequestStatusModal-module__modalVersionRequestStatus--Y9e4R{display:flex;flex-direction:column}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusModal--Wwicy{width:600px;min-height:250px}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusLabel--HjT5m{color:var(--gray-6)}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusWrapper--ul14C{margin-top:10px}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusDescription--MuWJl{margin-top:32px;display:flex;color:var(--gray-6);align-items:center}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusComment--R6Ivm{margin-top:32px}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusCommentIcon--PywpZ{display:flex;margin-left:4px;align-items:center}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusCommentInput--IvDye{margin-top:10px}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusConfirmationModal--c8Rn2{width:460px !important}.ModelVersionRequestStatusModal-module__modalVersionRequestStatusConfirmationModal--c8Rn2 .basic-modal-content{font-weight:400;font-size:14px;line-height:21px;color:var(--gray-6)}.ModelVersionRequestStatusModal-module__fields-list--Vqn2F{display:flex;flex-direction:column;gap:8px}.ModelVersionRequestStatusModal-module__fields-list-item--u49H3{display:flex;align-items:stretch;width:100%}.ModelVersionRequestStatusModal-module__fields-list-inputs--dfoDF{display:flex;flex-grow:1;gap:8px;width:92%}.ModelVersionRequestStatusModal-module__fieldInput--cFl02{flex-grow:1;height:36px}.ModelVersionRequestStatusModal-module__removeButtonWrapper--KOV25 .ModelVersionRequestStatusModal-module__removeButton--sLTd5{display:flex;justify-content:center;align-items:center;min-width:16px;width:16px;height:16px;padding:0;margin:auto;color:#b3b9c8;cursor:pointer}.ModelVersionRequestStatusModal-module__removeButton--sLTd5:disabled{color:#ccc;cursor:not-allowed;pointer-events:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `ModelVersionRequestStatusModal-module__dsAccented--lGt3E`,
	"dsDefaultWeight": `ModelVersionRequestStatusModal-module__dsDefaultWeight--Z2GpU`,
	"dsUnderline": `ModelVersionRequestStatusModal-module__dsUnderline--NFsql`,
	"dsAccented2": `ModelVersionRequestStatusModal-module__dsAccented2--DdP_v`,
	"dsBodyXL": `ModelVersionRequestStatusModal-module__dsBodyXL--KMKOQ`,
	"dsBodyLarge": `ModelVersionRequestStatusModal-module__dsBodyLarge--qIeQx`,
	"dsBody": `ModelVersionRequestStatusModal-module__dsBody--AlUL_`,
	"dsBodySmall": `ModelVersionRequestStatusModal-module__dsBodySmall--XTiaP`,
	"dsBodyXS": `ModelVersionRequestStatusModal-module__dsBodyXS--uOgCm`,
	"dsActionLarge": `ModelVersionRequestStatusModal-module__dsActionLarge--HKdcp`,
	"dsAction": `ModelVersionRequestStatusModal-module__dsAction--ba3vI`,
	"dsActionSmall": `ModelVersionRequestStatusModal-module__dsActionSmall--iOaPi`,
	"dsColumnHeadLine": `ModelVersionRequestStatusModal-module__dsColumnHeadLine--Hqu3n`,
	"dsLightXL": `ModelVersionRequestStatusModal-module__dsLightXL--XhecA`,
	"dsLightLarge": `ModelVersionRequestStatusModal-module__dsLightLarge--TRIGq`,
	"dsLight": `ModelVersionRequestStatusModal-module__dsLight--SvZ_v`,
	"dsLightSmall": `ModelVersionRequestStatusModal-module__dsLightSmall--nDxLn`,
	"dsLightXS": `ModelVersionRequestStatusModal-module__dsLightXS--rH_1Q`,
	"modalVersionRequestStatus": `ModelVersionRequestStatusModal-module__modalVersionRequestStatus--Y9e4R`,
	"modalVersionRequestStatusModal": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusModal--Wwicy`,
	"modalVersionRequestStatusLabel": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusLabel--HjT5m`,
	"modalVersionRequestStatusWrapper": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusWrapper--ul14C`,
	"modalVersionRequestStatusDescription": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusDescription--MuWJl`,
	"modalVersionRequestStatusComment": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusComment--R6Ivm`,
	"modalVersionRequestStatusCommentIcon": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusCommentIcon--PywpZ`,
	"modalVersionRequestStatusCommentInput": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusCommentInput--IvDye`,
	"modalVersionRequestStatusConfirmationModal": `ModelVersionRequestStatusModal-module__modalVersionRequestStatusConfirmationModal--c8Rn2`,
	"fields-list": `ModelVersionRequestStatusModal-module__fields-list--Vqn2F`,
	"fields-list-item": `ModelVersionRequestStatusModal-module__fields-list-item--u49H3`,
	"fields-list-inputs": `ModelVersionRequestStatusModal-module__fields-list-inputs--dfoDF`,
	"fieldInput": `ModelVersionRequestStatusModal-module__fieldInput--cFl02`,
	"removeButtonWrapper": `ModelVersionRequestStatusModal-module__removeButtonWrapper--KOV25`,
	"removeButton": `ModelVersionRequestStatusModal-module__removeButton--sLTd5`
};
module.exports = ___CSS_LOADER_EXPORT___;
